import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import { Tooltip } from "@mui/material";
import { Plyr } from "plyr-react";
import "plyr/dist/plyr.css";
import { useState,useEffect } from "react";

import noThumbnail from "../../noThumbnail.png";
import noVideoImage from "../../NTV.png";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import {
  EditIcon,
  JPGIconSmall,
  PdfIconSmall,
} from "../../../../../assets/CommonAssets";
import { baseUrlTraining, trainingApiClient } from "../../../../../http-common";

const Card = ({
  course,
  filePreview,
  setFilePreview,
  renderFilePreview,
  open,
  setOpen,
  openPostAsstModal,
  setOpenPostAsstModal,
  setSelectedRow,
  selectedRow,
  testData,
  setTrainingModalOpen,
  trainingModalOpen,
  selectedDataForAssessment,
  setSelectedDataForAsessment,
  getAssessmentQuestions,
  getTrainingDoc,
}) => {
  const {
    Training,
    Description,
    duration,
    thumbnail,
    // videoUrldata,
    Document,
    status,
  } = course;

  const [videoUrl, setVideoUrl] = useState("");
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);

  const parsedDocs = Document?.length > 0 ? JSON.parse(Document) : [];
  const videoDoc = parsedDocs?.find((obj) => obj?.type?.startsWith("video/"));
  const videoUrldata = videoDoc ? videoDoc?.url : null;
  const videoList = parsedDocs?.filter((obj) =>
    obj?.type?.startsWith("video/"),
  );

  const videoUrls = videoList?.map((video) => `${video?.url}`);
  useEffect(() => {
    return () => {
      if (videoUrl && videoUrl !== "loading") {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [videoUrl]);
  return (
    <>
      <div
        className="
        w-full
        bg-white
        border border-gray-200
        rounded-[23px]
        px-4 py-3
        shadow-sm
        transition-all duration-300
        hover:-translate-y-[2px]
        hover:shadow-xl
        hover:border-cyan-200
        hover:bg-gradient-to-r hover:from-cyan-50 hover:to-blue-50
      "
      >
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-[18px] font-semibold text-customBlue">
            {Training}
          </h3>

          <button
            onClick={() => {
              setSelectedRow(course);
              setTrainingModalOpen(true);
            }}
            className="p-1 rounded-md text-gray-500 hover:text-customBlue hover:bg-gray-100 transition"
          >
            <EditIcon title={"Edit"} />
          </button>
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-[17%]">
            <div
              className="
              h-[160px]
              rounded-xl
              bg-cover bg-center
              relative cursor-pointer group
              overflow-hidden
              shadow-md
            "
              style={{
                backgroundImage: `url(${
                  videoUrldata ? thumbnail || noThumbnail : noVideoImage
                })`,
                cursor: videoUrldata ? "pointer" : "not-allowed",
              }}
              // onClick={() => {
              //   if (!videoUrldata) return;
              //   setVideoUrl(videoUrldata);
              // }}
              onClick={() => {
                if (videoUrls?.length > 0) {
                  setSelectedVideoIndex(0);
                  const firstVideo = videoList?.[0];
                  console.log("triggered");
                  // setVideoUrl("loading"); // ← ye line hai? Modal turant open hoga

                  getTrainingDoc(firstVideo?.name, firstVideo, (blobUrl) => {
                    if (!blobUrl) {
                      setVideoUrl(null);
                      return;
                    }
                    setVideoUrl(blobUrl);
                  });
                }
              }}
            >
              {/* overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent opacity-70 transition" />

              {/* play button */}
              {videoUrldata && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div
                    className="
                    w-14 h-14 rounded-full
                    bg-black/50 text-white
                    flex items-center justify-center
                    shadow-xl
                    scale-90 group-hover:scale-100
                    transition-all duration-300
                  "
                  >
                    <Tooltip title="Play">
                      <PlayArrowOutlinedIcon fontSize="large" />
                    </Tooltip>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="w-full md:w-[58%] flex flex-col justify-between">
            <div className="space-y-2">
              <p className="text-[15px] text-gray-600 line-clamp-2">
                <span className="font-semibold text-gray-800">
                  Description :
                </span>{" "}
                {Description}
              </p>
            </div>

            <div className="flex gap-2 mt-3">
              {Document?.length > 0 &&
                JSON?.parse(Document)?.map((obj, index) => (
                  <div key={index}>
                    {obj?.type === "application/pdf" && (
                      <Tooltip title={obj?.name || ""}>
                        <span>
                          <PdfIconSmall
                            onClick={() => {
                              // setFilePreview(obj);
                              // renderFilePreview();
                              getTrainingDoc(obj?.name, obj);
                            }}
                          />
                        </span>
                      </Tooltip>
                    )}

                    {obj?.type?.startsWith("image/") && (
                      <Tooltip title={obj?.name || ""}>
                        <div>
                          <JPGIconSmall
                            onClick={() => {
                              getTrainingDoc(obj?.name, obj);
                            }}
                          />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div className="w-full md:w-[25%] space-y-3">
            <div className="flex gap-2">
              {course?.["Pre Assessment Required"] && (
                <CommonButton
                  className="
                  w-full rounded-[6px]
                  border border-customBlue
                  text-customBlue
                  transition-all duration-300
                  hover:bg-customBlue hover:text-white
                  hover:shadow-lg hover:-translate-y-[1px]
                  active:scale-95
                "
                  label="Pre Assessment"
                  onClick={() => {
                    setSelectedDataForAsessment(course);
                    getAssessmentQuestions(course?.Id, course?.PreId);
                  }}
                />
              )}

              {course?.["Post Assessment Required"] && (
                <CommonButton
                  className="
                  w-full rounded-[6px]
                  border border-customBlue
                  text-customBlue
                  transition-all duration-300
                  hover:bg-customBlue hover:text-white
                  hover:shadow-lg hover:-translate-y-[1px]
                  active:scale-95
                "
                  label="Post Assessment"
                  onClick={() => {
                    setSelectedDataForAsessment(course);
                    getAssessmentQuestions(course?.Id, course?.PostId);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* {videoUrl && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center">
          <div className="relative w-[95%] md:w-[80%] lg:w-[70%] xl:w-[60%] bg-[#0f172a] rounded-2xl shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
              <h3 className="text-white font-semibold text-lg">{Training}</h3>

              <button
                onClick={() => setVideoUrl(null)}
                className="text-gray-300 hover:text-white transition"
              >
                <CloseModalIcon />
              </button>
            </div>

      
            <div className="bg-black">
              <Plyr
                source={{
                  type: "video",
                  sources: [{ src: videoUrl, type: "video/mp4" }],
                }}
                options={{
                  autoplay: true,
                  controls: [
                    "play-large",
                    "play",
                    // "progress",
                    "current-time",
                    "mute",
                    "volume",
                    // "settings",
                    "fullscreen",
                  ],
                }}
              />
            </div>
          </div>
        </div>
      )} */}
      {videoUrl && (
        <div className="fixed inset-0 z-[1200] bg-black/70 backdrop-blur-md flex items-center justify-center">
          <div
            className={`relative video-modal
        ${
          videoUrls?.length > 1
            ? "w-[98%] md:w-[92%] lg:w-[88%] xl:w-[85%]"
            : "w-[95%] md:w-[80%] lg:w-[70%] xl:w-[60%]"
        }
        bg-gradient-to-br from-[#0f172a] to-[#020617] 
        rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] 
        overflow-hidden animate-[fadeIn_0.3s_ease-out] 
        border border-white/10 transition-all duration-300`}
          >
            <div
              className={`flex justify-between items-center px-6 py-2 border-b border-white/10 `}
            >
              <h3 className="text-white font-semibold text-lg tracking-wide truncate">
                {course?.Training}
              </h3>
              <button onClick={() => setVideoUrl(null)} className="p-2">
                <CloseModalIcon />
              </button>
            </div>

            <div className="flex flex-col md:flex-row h-[70vh]">
              <div
                className={`w-full ${
                  videoUrls?.length > 1 ? "md:w-[70%]" : "md:w-full"
                } p-1 flex flex-col`}
              >
                <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg flex-1">
                  <div key={videoUrl} className="h-full">
                    <Plyr
                      source={{
                        type: "video",
                        sources: [{ src: videoUrl, type: "video/mp4" }],
                      }}
                      options={{
                        autoplay: true,
                        controls: [
                          "play-large",
                          "play",
                          "current-time",
                          "mute",
                          "volume",
                          "fullscreen",
                        ],
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              {videoUrls?.length > 1 && (
                <div className="w-full md:w-[30%] h-full overflow-y-auto border-l border-white/10 bg-white/5 backdrop-blur-sm">
                  <div className="p-3 text-xs uppercase text-gray-400 tracking-wider">
                    Playlist
                  </div>

                  {videoList?.map((video, index) => (
                    <div
                      key={index}
                      // onClick={() => {
                      //   setSelectedVideoIndex(index);
                      //   setVideoUrl(videoUrls[index]);
                      // }}
                      // onClick={() => {
                      //   if (videoUrls?.length > 0 && !isPreAssessmentDone) {
                      //     setSelectedVideoIndex(0);
                      //     const firstVideo = videoList?.[0];

                      //     // Loading state dikhao jab tak blob aaye
                      //     setVideoUrl("loading"); // optional — modal open rakhne ke liye

                      //     getTrainingDoc(firstVideo?.fileName, (blobUrl) => {
                      //       setVideoUrl(blobUrl); // ← sirf blob URL
                      //     });
                      //   }
                      // }}
                      onClick={() => {
                        setSelectedVideoIndex(index);
                        // setVideoUrl("loading");
                        getTrainingDoc(video?.name, video, (blobUrl) => {
                          if (!blobUrl) {
                            setVideoUrl(null);
                            return;
                          }
                          setVideoUrl(blobUrl);
                        });
                      }}
                      className={`mx-2 mb-2 px-3 py-3 rounded-xl cursor-pointer flex items-center gap-3 transition-all duration-200
                  ${
                    selectedVideoIndex === index
                      ? "bg-gradient-to-r from-indigo-500/30 to-purple-500/30 text-white border border-indigo-400/40 shadow-md"
                      : "text-white hover:bg-white/10"
                  }`}
                    >
                      <div className="w-7 h-7 shrink-0 flex items-center justify-center text-xs rounded-full bg-white/10">
                        {index + 1}
                      </div>

                      <div className="flex-1 text-sm truncate">
                        {video?.name || `Video ${index + 1}`}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <style jsx>{`
            .video-modal .plyr {
              height: 100% !important;
            }
            .video-modal .plyr__video-wrapper {
              height: 100% !important;
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default Card;